import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import MeasurementUnitTableDto from '../dto/MeasurementUnitTableDto';

class MeasurementUnitTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'measurementUnitTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<MeasurementUnitTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, MeasurementUnitTableDto)))
				.catch(reject);
		});
	}
}

export default new MeasurementUnitTableService();
